import { reduxForm } from 'redux-form';

import Form from 'components/forms/ForgottenPasswordRequestForm';
import { focusFieldWithError } from 'utils/forms';

import asyncValidate from './asyncValidate';
import validate from './validate';
import { FORM_ID } from './constants';

export default reduxForm({
  form: FORM_ID,
  onSubmitFail: focusFieldWithError(FORM_ID),
  asyncValidate,
  asyncBlurFields: ['email'],
  validate,
})(Form);
